import { ImportFileLoadRowStatus } from './import-file-load-row-status';
import { ImportFileParseError } from './import-file-parse-error';
import { ImportFileValidationError } from './import-file-validation-error';

export class ImportFileLoadRowResult {

  public rowNumber: number;
  public rowValue: any[];
  public parseStatus: ImportFileLoadRowStatus;
  public parseErrors: ImportFileParseError[];

  public validationStatus: ImportFileLoadRowStatus;
  public validationErrors: ImportFileValidationError[];

  public importStatus: ImportFileLoadRowStatus;
  public errorMessage: string;

  public nbErrors = 0;

  public failed: boolean;

  static fromDto(data: any, unexpectedColumns): ImportFileLoadRowResult {
    if (!data) {
      return null;
    }

    const rowResult = new ImportFileLoadRowResult();

    let parseErrors: ImportFileParseError[] = [];
    if (data.parse_errors) {
      parseErrors = data.parse_errors.map(e => ImportFileParseError.fromDto(e));

      rowResult.nbErrors += parseErrors.length;
    }

    let validationErrors: ImportFileValidationError[] = [];
    if (data.validation_errors) {
      validationErrors = data.validation_errors.map(e => ImportFileValidationError.fromDto(e));

      rowResult.nbErrors += validationErrors.length;
    }

    rowResult.rowNumber        = data.row_number;
    rowResult.rowValue         = data.row_value || [];
    rowResult.parseStatus      = data.parse_status;
    rowResult.parseErrors      = parseErrors;
    rowResult.validationStatus = data.validation_status;
    rowResult.validationErrors = validationErrors;
    rowResult.importStatus     = data.import_status;
    rowResult.errorMessage     = data.error_message;

    rowResult.failed = rowResult.parseStatus !== ImportFileLoadRowStatus.SUCCEED || rowResult.validationStatus !== ImportFileLoadRowStatus.SUCCEED;

    rowResult.rowValue = rowResult.rowValue.filter((v, i) => unexpectedColumns.findIndex(c => c.position === i) === -1);

    return rowResult
  }
}
